export const CHAT_ASSISTANT_FLAG_KEY = 'chatbot-enabled';
export const DARK_MODE_TOGGLE_FLAG_KEY = 'darkmode-enabled';

export type LaunchDarklyApp = 'portal' | 'mira' | 'docs';

export const getLaunchDarklyClientSideId = (): string | undefined =>
  process.env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID?.trim() || undefined;

export const isLaunchDarklyConfigured = (): boolean => Boolean(getLaunchDarklyClientSideId());
